<template>
  <div></div>
</template>

<script>
import { showErrorNotification, showSuccessNotification } from '@/utils/notification';

export default {
  async created() { // TODO: Refactor in new auth account component
    try {
      switch (this.$route.query.mode) {
        case 'resetPassword': // Display reset password handler and UI.
          this.$store.dispatch('user/auth/handleResetPasswordValidityCheck', {
            actionCode: this.$route.query.oobCode,
          }).then((userEmail) => {
            // TODO: Remove commit
            this.$store.commit('user/auth/SET_USER', {
              email: userEmail,
            });
            this.$router.push({
              name: 'AuthResetPasswordSetPassword',
              query: {
                email: userEmail,
                actionCode: this.$route.query.oobCode,
              },
            });
          }).catch((error) => {
            this.$router.push({
              name: 'AuthResetPasswordSendEmail',
              params: {
                title: 'Try resetting your password again.',
              },
            });
            showErrorNotification(error.message, 8000);
          });
          break;
        case 'recoverEmail': // TODO: Display email recovery handler and UI.
          this.$router.push({ name: 'Dashboard' });
          break;
        case 'verifyEmail': // Display email verification handler and UI.
          await this.$store.dispatch('user/auth/handleVerifyEmail', {
            actionCode: this.$route.query.oobCode,
            continueUrl: this.$route.query.continueUrl,
          });

          this.$router.push({ name: 'Dashboard' });
          showSuccessNotification('Your Email was verified successfully.', 3000);
          break;
        default: // Error: invalid mode.
          showErrorNotification('Invalid mode.', 8000);
      }
    } catch (error) { // Catch allEvents rejected promises
      this.$router.push({ name: 'Dashboard' });
      showErrorNotification(error.message, 8000);
    }
  },
};
</script>

<style scoped>
</style>
